<form class="layout-form" [formGroup]="taxForm" (ngSubmit)="onSubmit()">
  <div class="component-content">
    <div class="form-header">
      <p>Datos Impositivos</p>
      <span> Complete con sus datos impositivos </span>
    </div>
    <div class="scroll-display">
      <div class="form-select-content">
        <div class="form-customer-data" #errorDiv>
          <!-- <app-select  [attr.data-testid]="'condition-iibb'" 
                        [labelText]="'Seleccione el tipo de persona'" [placeholder]="'Seleccionar'" [required]="true" 
                        formControlName="typePerson" [submitted]="submitted" [options]="personOption">
                    </app-select> -->
          <mat-radio-group aria-label="Select an option" formControlName="typePerson">
            <mat-radio-button class="radio-button" *ngFor="let person of personOption" [value]="person.value">{{
              person.text
            }}</mat-radio-button>
            <div *ngIf="submitted && !this.taxForm.controls['typePerson'].valid">
              <label class="warning-label">Debes elegir RUC o CI</label>
            </div>
          </mat-radio-group>
        </div>
        <div *ngIf="this.taxForm.controls['typePerson'].value == 'F'">
          <app-text-input
            [labelText]="'Cedula de identidad'"
            [type]="'text'"
            [min]="6"
            [max]="8"
            [required]="true"
            formControlName="ci"
            [submitted]="submitted"
            [placeholder]="'0000000'"
            ddata-testid="ci-input"
          >
          </app-text-input>
          <label class="warning-label" *ngIf="isDuplicated">
            {{ warningCuitText }}
          </label>
          <div class="form-customer-data">
            <app-file-upload-component
              [labelText]="'Frente de CI'"
              [required]="true"
              [submitted]="submitted"
              [oneFile]="true"
              [documentId]="21"
              [isImg]="true"
              [ocrValidation]="false"
              [extensions]="['.png', '.jpeg', '.jpg']"
              formControlName="fileBackCi"
              [maxSizeFile]="20"
              [id]="'fileBackCiId'"
              data-testid="ci-back-file"
            >
            </app-file-upload-component>
            <app-file-upload-component
              [labelText]="'Dorso de CI'"
              [required]="true"
              [submitted]="submitted"
              [oneFile]="true"
              [documentId]="22"
              [isImg]="true"
              [ocrValidation]="true"
              [extensions]="['.png', '.jpeg', '.jpg']"
              formControlName="fileFrontCi"
              [maxSizeFile]="20"
              [id]="'fileFrontCiId'"
              data-testid="ci-back-file"
            >
            </app-file-upload-component>
            <div *ngIf="ocrError">
              <label class="warning-label"
                >No fue posible validar la CI. Por favor, adjunte nuevamente la imagen del dorso</label
              >
            </div>
          </div>
          <div class="form-customer-data">
            <app-text-input
              [labelText]="'Nombre'"
              [type]="'text'"
              [required]="true"
              formControlName="name"
              [submitted]="submitted"
              data-testid="name-input"
            >
            </app-text-input>
            <app-text-input
              [labelText]="'Apellido'"
              [type]="'text'"
              [required]="true"
              formControlName="surname"
              [submitted]="submitted"
              data-testid="surname-input"
            >
            </app-text-input>
          </div>
        </div>

        <div *ngIf="this.taxForm.controls['typePerson'].value == 'J'">
          <div class="form-customer-data">
            <app-text-input
              [labelText]="'RUC'"
              [type]="'text'"
              [required]="true"
              [min]="7"
              [max]="12"
              formControlName="ruc"
              [submitted]="submitted"
              [placeholder]="'0000000000-0'"
              data-testid="ruc-input"
            >
            </app-text-input>
            <label class="warning-label" *ngIf="isDuplicated">
              {{ warningCuitText }}
            </label>
          </div>
          <div class="form-customer-data">
            <app-text-input
              [labelText]="'Razon social'"
              [type]="'text'"
              [required]="true"
              [max]="40"
              [min]="1"
              formControlName="socialReason"
              [submitted]="submitted"
              data-testid="social-reason"
            >
            </app-text-input>
          </div>
          <app-text-input
            [labelText]="'Cedula de identidad'"
            [type]="'number'"
            [min]="6"
            [required]="true"
            formControlName="ci"
            [submitted]="submitted"
            [placeholder]="'0000000'"
            ddata-testid="ci-input"
          >
          </app-text-input>
          <div class="form-customer-data">
            <app-text-input
              [labelText]="'Nombre'"
              [type]="'text'"
              [required]="true"
              formControlName="name"
              [submitted]="submitted"
              data-testid="name-input"
            >
            </app-text-input>
          </div>
          <div class="form-customer-data">
            <app-text-input
              [labelText]="'Apellido'"
              [type]="'text'"
              [required]="true"
              formControlName="surname"
              [submitted]="submitted"
              data-testid="surname-input"
            >
            </app-text-input>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="form-navigation">
    <app-navigation [currentStep]="4" [countSteppers]="7"></app-navigation>
  </div>
  <div class="button-container">
    <button mat-raised-button class="back-button" type="button" (click)="back()">Anterior</button>
    <button mat-raised-button class="next-button next-button__60" type="submit">Siguiente</button>
  </div>
</form>
